/**
 * CargaOpenlog
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaOpenlogCollection} from '@/model/collection/CargaOpenlogCollection'

/* TODO: review generated class */
export class CargaOpenlog extends Resource {
  idCodigoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  idPedido: string | null = null

  get $id() {
    return this.idCodigoPk
  }
  set $id(val) {
    this.idCodigoPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaOpenlog
   */
  async getCargaOpenlog(id: number) {
    return await Request.get(`/admin/carga-openlog/${id}`)
      .name('getCargaOpenlog')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaOpenlog
   */
  static async listCargaOpenlog(params: any) {
    return await Request.get(`/admin/carga-openlog`, {params})
      .name('listCargaOpenlog')
      .as(CargaOpenlogCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaOpenlog. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaOpenlog() {
    return await Request.post(`/admin/carga-openlog`, this)
      .name('persistCargaOpenlog')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaOpenlog to use it in a CSV file
   */
  static async listCsvCargaOpenlog(params: any) {
    return await Request.get(`/admin/carga-openlog/csv`, {params})
      .name('listCsvCargaOpenlog')
      .as(CargaOpenlogCollection)
      .getData()
  }
}
